<template>
  <div class="jgsd-report-review">
    <div class="item">
      <div class="hd">
        审读记录统计
      </div>
      <div class="bd">
        <div
          class="bd_item bd_item-statistics"
          v-for="(item, index) in proportionArray"
          :key="index"
        >
          <div class="bd_item-top">
            {{ item.name }}
            <a
              v-if="item.label !== 'pending' && item.count !== 0"
              @click="toDetail(item.status)"
            >查看明细>></a>
          </div>
          <div class="bd_item-content">
            <span class="percent">
              <i
                :class="['icon', `icon-jgsd-report-statistics-${item.label}`]"
              />{{ item.proportion + "%" }}</span>
            <span
              class="number"
            >{{ item.count }}/<em>{{ item.total }}</em></span>
            <el-progress
              :show-text="false"
              :stroke-width="3"
              :percentage="item.proportion"
              color="#fff"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="hd">
        审读稿件统计
        <div class="hd_status">
          <label>审读状态：</label>
          <el-radio-group
            v-model="status"
            @change="init"
          >
            <el-radio-button
              v-for="(item, index) in baseData"
              :key="index"
              :label="item.status"
            >
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="bd">
        <pie
          class="bd_item"
          echarts-id="total"
          :data-list="totalPie"
          :color="['#4976F6', '#5FD4C0']"
          echarts-title="稿件分布"
        />
        <pie
          class="bd_item"
          echarts-id="system1"
          :data-list="folderPie"
          :color="['#EA5534', '#F39B3E','#1F9DE5','#5BE1E6','#9D85EE','#51D9B7','#53C971']"
          echarts-title="互联网数据-稿件类型分布"
        />
        <pie
          class="bd_item"
          echarts-id="system0"
          :data-list="articlePie"
          :color="['#EA5534', '#F39B3E','#1F9DE5','#5BE1E6','#9D85EE','#51D9B7']"
          echarts-title="上传数据-稿件类型分布"
        />
      </div>
    </div>
    <!-- 审读结果统计 -->
    <div class="item">
      <div class="hd">
        各机构审读结果统计
      </div>
      <reviewTable
        class="depart-table"
        :thead="thead"
        :tpropty="tpropty"
        :table-data="tableData"
        @handleRowClick="handleRowClick"
      />
    </div>
    <detailDialog
      ref="detailDialog"
      :title="title"
      :article-type="articleType"
      :folder-type="folderType"
      :base-params="baseParams"
    />
  </div>
</template>

<script>
import pie from '@components/echarts/pie'
import reviewTable from '@components/jgsd/table'
import detailDialog from './detailDialog.vue'
import APIS from '@apis/jgsd/report.js'
export default {
  name: 'Review',
  props: {
    indicatorData: {
      type: Object,
      default: () => {}
    },
    getTimeParams: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    pie,
    reviewTable,
    detailDialog
  },
  data() {
    return {
      status: '6',
      baseData: [
        {
          name: '不通过',
          status: '6',
          label: 'notPassed'
        },
        {
          name: '已通过',
          status: '5',
          label: 'passed'
        },
        {
          name: '待审读',
          status: '4',
          label: 'pending'
        }
      ],
      totalType: {
        system1: '互联网数据',
        system0: '上传数据'
      },
      totalPie: [],
      articleType: {
        '1': '图文',
        '2': '图集',
        '3': '书籍文件',
        '4': '影视作品',
        '5': '视频',
        '6': '音频'
      },
      articlePie: [],
      folderType: {
        news: '网站',
        app: 'APP',
        weibo: '微博',
        wechat: '微信',
        epaper: '数字报',
        wemedia: '自媒体',
        video: '短视频'
      },
      folderPie: [],
      thead: ['', '所属机构', '总稿件量', '互联网稿件量', '上传数据稿件量'],
      tpropty: ['index', 'name', 'sum', 'system1', 'system0'],
      tableData: [],
      baseParams: {},
      title: '稿件明细列表'
    }
  },
  computed: {
    proportionArray() {
      return this.baseData.map(item => {
        return {
          ...item,
          count: this.indicatorData[item.label] || 0,
          total: this.indicatorData[item.label === 'pending' ? 'sum' : 'total'],
          proportion: this.indicatorData[`${item.label}Percent`] || 0
        }
      })
    },
    getParams() {
      return Object.assign({}, this.getTimeParams, { oriStatus: this.status })
    },
    totalKeys() {
      return Object.keys(this.totalType)
    },
    articleKeys() {
      return Object.keys(this.articleType)
    },
    folderKeys() {
      return Object.keys(this.folderType)
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getStatisticsSystem()
      this.getStatisticsArticleType()
      this.getStatisticsFolder()
      this.getStatisticsDepartment()
    },
    // 上传和互联网占比统计
    async getStatisticsSystem() {
      let { status, data } = await APIS.postStatisticsSystem({
        data: this.getParams
      })
      this.totalPie = this.totalKeys.map(item => {
        return {
          name: this.totalType[item],
          value: status !== 0 || JSON.stringify(data) === '{}' ? 0 : data[item]
        }
      })
    },
    // 上传数据统计
    async getStatisticsArticleType() {
      let { status, data } = await APIS.postStatisticsArticleType({
        data: this.getParams
      })
      this.articlePie = this.articleKeys.map(item => {
        return {
          name: this.articleType[item],
          value:
            status !== 0 || JSON.stringify(data) === '{}' ? 0 : data[item] || 0
        }
      })
    },
    // 互联网数据统计
    async getStatisticsFolder() {
      let { status, data } = await APIS.postStatisticsFolder({
        data: this.getParams
      })
      this.folderPie = this.folderKeys.map(item => {
        let video =
          (data.video || 0) +
          (data.douyin || 0) +
          (data.kuaishou || 0) +
          (data.miaopai || 0) +
          (data.bilibili || 0)
        return {
          name: this.folderType[item],
          value:
            status !== 0 || JSON.stringify(data) === '{}'
              ? 0
              : item === 'video'
                ? video
                : (data[item] || 0)
        }
      })
    },
    // 各机构审读结果统计
    async getStatisticsDepartment() {
      let { status, data } = await APIS.postStatisticsDepartment({
        data: this.getParams
      })
      if (status === 0 && data && data.length !== 0) {
        this.tableData = data.map((item, index) => {
          return {
            index: index + 1,
            id: item.departmentId,
            name: item.departmentName,
            sum: item.sum || 0,
            system0: item.system0 || 0,
            system1: item.system1 || 0
          }
        })
      } else {
        this.tableData = []
      }
    },
    toDetail(status) {
      this.baseParams = Object.assign({}, this.getTimeParams, {
        status: status
      })
      this.title = '稿件明细列表'
      this.$refs.detailDialog.$refs.dialogCommon.cyDialogCommon = true
      this.$nextTick(() => {
        this.$refs.detailDialog.init()
      })
    },
    handleRowClick(value) {
      if (value.prop !== 'system1' && value.prop !== 'system0') return false
      if (value[value.prop] === 0) return false
      let isInterNet = value.prop === 'system1'
      let title = isInterNet ? '互联网' : '上传'
      this.title = `${value.name}-${title}数据审读结果明细`
      this.baseParams = Object.assign({}, this.getTimeParams, {
        system: isInterNet ? 1 : 0,
        status: this.status
      })
      this.$refs.detailDialog.$refs.dialogCommon.cyDialogCommon = true
      this.$nextTick(() => {
        this.$refs.detailDialog.init({ id: value.id, name: value.name })
      })
    }
  },
  watch: {
    getTimeParams: {
      handler(newVal) {
        if (!newVal) return false
        this.init()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.jgsd-report-review {
  .item {
    .hd {
      &_status {
        display: flex;
        align-items: center;
        margin-left: 39px;
        font-size: 13px;
        color: #666;
        /deep/ .el-radio-group {
          .el-radio-button {
            &__inner {
              border: 1px solid #e7e7e7;
              border-radius: 5px;
              font-size: 12px;
              color: #454647;
              padding: 8px 11px;
              box-shadow: none;
              outline: none;
            }
            + .el-radio-button {
              margin-left: 10px;
            }
            &.is-active {
              .el-radio-button__inner {
                border-color: #4497ec;
                color: #4f9ded;
                background: rgba(68, 151, 236, 0.15);
              }
            }
          }
        }
      }
    }
    .bd {
      &_item {
        &-top {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          align-items: center;
          a {
            font-size: 12px;
            cursor: pointer;
          }
        }
        &-content {
          position: relative;
          span.percent {
            display: inline-flex;
            margin: 20px 0 6px;
            align-items: center;
            font-size: 24px;
            font-weight: 400;
            font-family: FZZhengHeiS-EB-GB;
            i {
              margin: 0 11px 0 7px;
            }
          }
          span.number {
            position: absolute;
            right: 0;
            bottom: 6px;
            font-size: 12px;
            em {
              color: rgba(228, 232, 252, 1);
              font-style: normal;
            }
          }
          /deep/ .el-progress-bar {
            &__outer {
              background: rgba(255, 255, 255, 0.3);
            }
          }
        }
        &-statistics {
          border-radius: 5px;
          height: 110px;
          color: #fff;
          padding: 17px 19px 17px 23px;
          @each $i, $value in(1: #97a5f2, 2: #94c3f3, 3: #f1ac9c) {
            &:nth-of-type(#{$i}) {
              background: #{$value};
            }
          }
        }
      }
    }
    &:nth-child(3) {
      .hd {
        &::before {
          display: none;
        }
      }
    }
  }
}
</style>
